import { createContext, useContext } from 'react';
export const ExperimentsContext = createContext(undefined);
export const useExperiments = ()=>{
    const experiments = useContext(ExperimentsContext) || {};
    return {
        experiments,
        isExperimentEnabled: (spec)=>experiments[spec] === true || experiments[spec] === 'true' || false
    };
};

//# sourceMappingURL=experiments-context.js.map